import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import hook from './hook'
import HomeView from '../views/HomeView.vue'
import serviceRouter from './service'
import CloseAccountRouter from './close-account'
import Jijia from './jijia'
import JijiaDeviceVerify from './jijia-device-verify'
import Insurance from './insurance'
import DeviceReplaceV3 from './device-replace-v3'
import conpleteMachineDelivery from './complete-machine-delivery'
import MalfunctionRepair from './malfunction-repair'

import WxBind from './wx-bind'
import NameplateReissue from './nameplate-reissue'
import TrainNetwork from './train-network'
import Notice from './notice'
import Activity from './activity'
import Invoice from './invoice'
import MyCredentials from './my-credentials'
import Audit from './audit'
import AgriculturalLoan from './agricultural-loan'
import Page from './page'
import commonRedirectPage from '@/views/common-redirect-page.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  } as RouteRecordRaw,
  {
    path: '/common-redirect-page',
    name: 'CommonRedirectPage',
    component: commonRedirectPage,
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "devices" */ '@/views/Login.vue'),
  },
  {
    path: '/devices/my-credentials',
    name: 'devices22',
    redirect: {
      name: 'my-credentials-detail',
    },
    //component: () => import(/* webpackChunkName: "devices" */ '@/views/device/index.vue'),
    // beforeEnter: (to, from, next) => {
    //   next({name: 'expect'})
    // }
  },
  {
    path: '/devices',
    name: 'devices',
    redirect: {
      name: 'malfunction-repair-devices',
    },
    //component: () => import(/* webpackChunkName: "devices" */ '@/views/device/index.vue'),
    // beforeEnter: (to, from, next) => {
    //   next({name: 'expect'})
    // }
  },
  {
    path: '/networkpoints',
    name: 'networkpoints',
    redirect: { name: 'networkpoint-list' },
    component: () =>
      import(/* webpackChunkName: "networkpoints" */ '@/views/networkpoint/index.vue'),
    children: [
      {
        path: 'list',
        name: 'networkpoint-list',
        component: () =>
          import(/* webpackChunkName: "networkpoints" */ '@/views/networkpoint/list.vue'),
      },
      {
        path: 'detail/:guid',
        name: 'networkpoint-detail',
        component: () =>
          import(/* webpackChunkName: "networkpoints" */ '@/views/networkpoint/detail.vue'),
      },
    ],
  },
  {
    path: '/networkpoints/devices/:guid',
    name: 'networkpoints-devices',
    component: () =>
      import(/* webpackChunkName: "networkpoints" */ '@/views/networkpoint/devices.vue'),
  },
  {
    path: '/fault',
    name: 'fault',
    redirect: { name: 'fault-form' },
    component: () => import(/* webpackChunkName: "fault" */ '@/views/fault/index.vue'),
    children: [
      {
        path: 'test',
        name: 'fault-test',
        component: () => '',
      },
      {
        path: 'form',
        name: 'fault-form',

        component: () => import(/* webpackChunkName: "fault" */ '@/views/fault/form.vue'),
      },
      {
        path: 'address',
        name: 'fault-address',
        component: () => import(/* webpackChunkName: "fault" */ '@/views/fault/address.vue'),
      },
      {
        path: 'devices',
        name: 'fault-devices',

        component: () => import(/* webpackChunkName: "fault" */ '@/views/fault/devices.vue'),
      },
      {
        path: 'voucher/:sn',
        name: 'fault-voucher',
        component: () => import(/* webpackChunkName: "fault" */ '@/views/fault/voucher.vue'),
      },
      {
        path: 'networkpoints',
        name: 'fault-networkpoints',
        component: () => import(/* webpackChunkName: "fault" */ '@/views/fault/networkpoints.vue'),
      },
      {
        path: 'journal/:sn',
        name: 'fault-journal',
        component: () => import(/* webpackChunkName: "fault" */ '@/views/fault/journal.vue'),
      },
      {
        path: 'savebillsuccess',
        name: 'fault-savebillsuccess',
        component: () =>
          import(/* webpackChunkName: "fault" */ '@/views/fault/saveBillSuccess.vue'),
      },
      {
        path: 'list',
        name: 'fault-list',
        redirect: {
          name: 'malfunction-repair-order-list',
        },
        // component: () => import(/* webpackChunkName: "fault" */ '@/views/fault/list.vue'),
      },
      {
        path: 'content/:guid',
        name: 'fault-content',
        component: () => import(/* webpackChunkName: "fault" */ '@/views/fault/content.vue'),
      },
      {
        path: 'pointdetail/:guid',
        name: 'fault-pointdetail',
        component: () => '',
      },
      {
        path: 'protest',
        name: 'fault-protest',
        component: () => '',
      },
      {
        path: 'detection',
        name: 'fault-detection',
        component: () => import(/* webpackChunkName: "fault" */ '@/views/fault/detection.vue'),
      },
      {
        path: 'comment/:guid',
        name: 'fault-comment',
        component: () => import(/* webpackChunkName: "fault" */ '@/views/fault/comment.vue'),
      },
      {
        path: 'report/:guid',
        name: 'fault-report',
        component: () => import(/* webpackChunkName: "fault" */ '@/views/fault/report.vue'),
      },
    ],
  },
  {
    path: '/standby',
    name: 'standby',
    redirect: { name: 'standby-purchases' },
    component: () => import(/* webpackChunkName: "standby" */ '@/views/standby/index.vue'),
    children: [
      {
        path: 'purchases/:sn',
        name: 'standby-purchases',
        component: () => import(/* webpackChunkName: "standby" */ '@/views/standby/purchases.vue'),
      },
      {
        path: 'orderdetail/:sn',
        name: 'standby-orderdetail',
        component: () =>
          import(/* webpackChunkName: "standby" */ '@/views/standby/orderdetail.vue'),
      },
      {
        path: 'servicehistories/:sn',
        name: 'standby-servicehistories',
        component: () =>
          import(/* webpackChunkName: "standby" */ '@/views/standby/servicehistories.vue'),
      },
    ],
  },
  {
    path: '/maptalk',
    name: 'maptalk',
    component: () => import(/* webpackChunkName: "mapView" */ '@/views/MapView.vue'),
  },
  {
    path: '/AppView',
    name: 'AppView',
    component: () => import(/* webpackChunkName: "mapView" */ '@/views/AppView.vue'),
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/AboutView.vue'),
  },
  {
    path: '/expect',
    name: 'expect',
    component: () => import(/* webpackChunkName: "expect" */ '@/views/Expect.vue'),
  },

  Invoice as RouteRecordRaw,
  {
    path: '/map-preview',
    name: 'map-preview',
    component: () => import(/* webpackChunkName: "map-preview" */ '@/views/map/Preview.vue'),
  },
  {
    path: '/iframe-wrap',
    name: 'iframe-wrap',
    component: () => import(/* webpackChunkName: "iframe-wrap" */ '@/views/Iframe-wrap.vue'),
  },
  {
    path: '/three-liability-insurance',
    name: 'three-liability-insurance',
    redirect: (to) => {
      return { name: 'service', query: { sn: to.query.sn } }
    },
    component: () =>
      import(
        /* webpackChunkName: "three-liability-insurance" */ '@/views/three-liability-insurance/index.vue'
      ),
    children: [
      {
        path: 'service',
        name: 'service',
        component: () =>
          import(
            /* webpackChunkName: "three-liability-insurance" */ '@/views/three-liability-insurance/service.vue'
          ),
      },
      {
        path: 'jijia-list',
        name: 'three-liability-jijia-list',
        component: () =>
          import(
            /* webpackChunkName: "three-liability-insurance" */ '@/views/three-liability-insurance/jijia-list.vue'
          ),
      },
      {
        path: 'third-party-drone',
        name: 'third-party-drone',
        component: () =>
          import(
            /* webpackChunkName: "three-liability-insurance" */ '@/views/three-liability-insurance/third-party-drone.vue'
          ),
      },
      {
        path: 'third-party-correct-select',
        name: 'third-party-correct-select',
        component: () =>
          import(
            /* webpackChunkName: "three-liability-insurance" */ '@/views/three-liability-insurance/components/third-party-correct-select.vue'
          ),
      },
      {
        path: 'change-the-insured',
        name: 'change-the-insured',
        component: () =>
          import(
            /* webpackChunkName: "three-liability-insurance" */ '@/views/three-liability-insurance/change-the-insured.vue'
          ),
      },
      {
        path: 'operator',
        name: 'operator',
        component: () =>
          import(
            /* webpackChunkName: "three-liability-insurance" */ '@/views/three-liability-insurance/operator.vue'
          ),
      },
      {
        path: 'period',
        name: 'period',
        component: () =>
          import(
            /* webpackChunkName: "three-liability-insurance" */ '@/views/three-liability-insurance/period.vue'
          ),
      },
      {
        path: 'add-operator',
        name: 'add-operator',
        component: () =>
          import(
            /* webpackChunkName: "three-liability-insurance" */ '@/views/three-liability-insurance/add-operator.vue'
          ),
      },
      {
        path: 'pingan2024-operator',
        name: 'add-pingan2024-operator',
        component: () =>
          import(
            /* webpackChunkName: "three-liability-insurance" */ '@/views/three-liability-insurance/pingan2024-operator.vue'
          ),
      },
      {
        path: 'pingan-offline-page',
        name: 'pingan-offline-page',
        component: () =>
          import(
            /* webpackChunkName: "three-liability-insurance" */ '@/views/three-liability-insurance/pingan-offline-page.vue'
          ),
      },
    ],
  },
  CloseAccountRouter as RouteRecordRaw,
  Jijia as RouteRecordRaw,
  JijiaDeviceVerify as RouteRecordRaw,
  Insurance as RouteRecordRaw,
  DeviceReplaceV3 as RouteRecordRaw,
  {
    path: '/insurance-order-list',
    name: 'insurance-order-list',
    component: () =>
      import(/* webpackChunkName: "insurance-order-list" */ '@/views/insurance-order-list.vue'),
  },
  conpleteMachineDelivery as RouteRecordRaw,
  MalfunctionRepair as RouteRecordRaw,
  WxBind as RouteRecordRaw,
  NameplateReissue as RouteRecordRaw,
  TrainNetwork as RouteRecordRaw,
  Notice as RouteRecordRaw,
  Activity as RouteRecordRaw,
  MyCredentials as RouteRecordRaw,
  Audit as RouteRecordRaw,
  {
    path: '/transfer/customer-service',
    name: 'transfer/customer-service',
    component: () =>
      import(/* webpackChunkName: "transfer" */ '@/views/transfer/customer-service.vue'),
  },
  AgriculturalLoan as RouteRecordRaw,
  Page as RouteRecordRaw,
]

for (let i = 0; i < serviceRouter.length; i++) {
  routes.push(serviceRouter[i])
}
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

hook(router)

export default router
